import React from 'react'
import {sampleLoadouts} from '../../Fixture_combatants.js'
import {runFullBattle} from './run-full-battle.js'
import CombatantModel from '../models/CombatantModel.js'
import {openWindowToReportingPage} from '../open-window-to-reporting-page.js'

class ReportingRunner extends React.Component {

  constructor() {
    super();

    this.state = {
      trialCount: 3
    };

    this.charConfigs = [
      ...sampleLoadouts,
      //...add more variations here sometime
    ];
  }

  handleChangeTrial() {
    this.setState({
      trialCount: parseInt( this.refs.trialSelectBox.value, 10)
    })
  }

  getTeamsFromSelectBoxes() {

    function getTeamNumber(id) {
      if (id.match(/^one/)) {
        return "one"
      }
      if (id.match(/^two/)) {
        return "two"
      }
      //leaving the door open for team three in the future
      return null;
    }

    let combatants = {};
    ["oneA", "oneB", "oneC", "twoA", "twoB", "twoC"].forEach(id => {
      const teamId = getTeamNumber(id);
      const refValue = this.refs[id].value;

      if (refValue !== "none" && teamId) {
        const loadout = this.charConfigs.find(char => char.name === refValue);
        combatants[id] = new CombatantModel({
          ...loadout,
          wantsToJoinTeam: teamId
        })
      }
    });
    return combatants;
  }

  handleRunButton() {
    const combatantData = this.getTeamsFromSelectBoxes();
    //console.log(combatantData);

    let battleCount = 0;
    let reports = [];

    const runOneBattle = () => {
      //This could be triggered by a button or something instead?
      runFullBattle(combatantData, report => {
        // console.log(report);
        reports.push(report);
        battleCount++;

        //Run another battle
        if (battleCount < this.state.trialCount) {

          setTimeout(function () {
            runOneBattle();
          }, 100); //give browser a tiny bit of space to breathe. We could be doing 99+ battles here.

        } else {
          //OR battles are done!

          openWindowToReportingPage(reports);
          console.log('done!!')
        }
      });
    };
    //Kickoff!
    runOneBattle();
  }


  renderTrialCountSelect() {
    return (
      <select ref="trialSelectBox" value={this.state.trialCount} onChange={this.handleChangeTrial.bind(this)}>
        {
          [1, 3, 9, 17, 99].map((value, i) => {
            return <option key={i} value={value}>{value}</option>
          })
        }
      </select>
    )
  }


  renderSelectBox(id = "") {

    return (
      <span key={id}>
        <select ref={id}>
          {
            this.charConfigs.map((charModel, i) => {

              return <option value={charModel.name} key={i}>{charModel.name}</option>
            })
          }
          <option value="none">(none)</option>
        </select>
      </span>
    )
  }


  render() {
    return (
      <div>

        <div>Team One:</div>
        <div>
          {
            ["oneA", "oneB", "oneC"].map(id => {
              return this.renderSelectBox(id)
            })
          }
        </div>
        <div>Team Two:</div>
        <div>
          {
            ["twoA", "twoB", "twoC"].map(id => {
              return this.renderSelectBox(id)
            })
          }
        </div>
        <div>
          <button onClick={this.handleRunButton.bind(this)}>Run Battles</button>

            {this.renderTrialCountSelect()}

        </div>
      </div>
    );
  }
}

export default ReportingRunner;


// WEBPACK FOOTER //
// ./src/battle/reporting-mode/ReportingRunner.js